import axios from "axios";
import { API } from "@/lib/site";

export const getToken = () => localStorage.getItem("regal_admin_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("regal_admin_token", t);
  else localStorage.removeItem("regal_admin_token");
};

export const adminApi = () =>
  axios.create({ baseURL: API, headers: { Authorization: `Bearer ${getToken()}` } });

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};
